module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Prestige Car Leasing & Contract Hire | Morgan Highfield & Land","short_name":"Prestige Car Leasing","start_url":"/","background_color":"#C6A15C","theme_color":"#C6A15C","display":"standalone","icon":"src/assets/icons-manifest/manifest.jpg","cache_busting_mode":"none","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
